/**
 * WD-5 — Warn user.
 * US-A07 AC3: warning is one of the moderator's five actions. The warning is
 * delivered as a `system` notification to the author.
 */
import { Form, Input } from 'antd'
import { useState } from 'react'
import { useAdminTranslate } from '@/providers/i18n-provider'
import { ConfirmDialog } from './ConfirmDialog'

export interface WarnUserDialogProps {
  open: boolean
  userName: string
  onConfirm: (payload: { message: string; reason: string }) => Promise<void> | void
  onCancel: () => void
}

export const WarnUserDialog = ({ open, userName, onConfirm, onCancel }: WarnUserDialogProps) => {
  const translate = useAdminTranslate()
  const [message, setMessage] = useState('')

  return (
    <ConfirmDialog
      open={open}
      title={translate('admin.dialogs.warn.title', { name: userName })}
      description={translate('admin.dialogs.warn.description')}
      confirmLabel={translate('admin.dialogs.warn.confirm')}
      requireReason
      reasonLabel={translate('admin.dialogs.warn.reasonLabel')}
      onConfirm={reason => onConfirm({ message: message.trim(), reason: reason ?? '' })}
      onCancel={onCancel}
    >
      <Form layout="vertical">
        <Form.Item label={translate('admin.dialogs.warn.messageLabel')} required>
          <Input.TextArea
            rows={3}
            maxLength={500}
            value={message}
            onChange={event => setMessage(event.target.value)}
          />
        </Form.Item>
      </Form>
    </ConfirmDialog>
  )
}
